export default "__VITE_ASSET__0U_3jC1S__"